import React from "react";
import { Input } from "../../ui/input";
import { Textarea } from "../../ui/text-area";

const ContactForm: React.FC = () => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const data = {
      name: formData.get("name"),
      email: formData.get("email"),
      message: formData.get("message"),
    };
    console.log(data);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="p-5 w-full max-w-sm bg-[#80808033] rounded-lg"
    >
      <h3 className="font-semibold text-[#182152] text-center">GET IN TOUCH</h3>
      <div className="mt-5 sm:pt-7 space-y-3">
        <Input
          className="bg-[#80808033] text-[#182152] text-sm shadow-none rounded-none border-none"
          name="name"
          placeholder="Your Name"
        />
        <Input
          className="bg-[#80808033] text-[#182152] text-sm shadow-none rounded-none border-none"
          name="contact"
          placeholder="Your Contact Number"
        />
        <Textarea
          className="bg-[#80808033] text-[#182152] text-sm shadow-none rounded-none border-none w-full resize-none overflow-auto h-[5rem] px-3 py-1"
          name="message"
          placeholder="How can we help?"
        />
      </div>
      {/* buttons div */}
      <div className="flex justify-between gap-3 py-3">
        <button className="border bg-transparent border-[#182152] text-[#182152] text-xs px-2 py-1 rounded hover:opacity-90 transition-all duration-200 ease-out">
          REQUEST CALLBACK
        </button>
        <button
          type="submit"
          className="bg-[#FF7E00] hover:bg-opacity-80 transition-all duration-200 ease-out text-[#182152] text-xs px-2 py-1 rounded"
        >
          SEND
        </button>
      </div>
    </form>
  );
};

export default ContactForm;
